export const breadcrumbItems = [
    { label: 'Inicio', url: '/' },
    { label: 'Cobranzas', url: `/cobranzas` },
    { label: 'Morosos', active: true },
];